import * as d3 from 'd3'

export default {

  methods: {

    event_Link(selection, item, data, col) {

      if (!col.filter) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
          d3.select(this).transition().duration(50).style('opacity', .4)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).style('opacity', 1)
      })
      .on('click', () => {
        this.link_Action(item, data, col) 
      })
    },


    link_Action(item, data, col) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: data[this.keys[d]]}
      })
      let filterString_ = this.filters[col.filter] || ''

      const result = item.length === 1 ? item[0]
                   : item.length === 2 ? item[1]
                   : ""; // 그 외는 빈값
      
      if (filterString_) filterString_ += ` AND [CAT] = '${result}'`
      else filterString_ += `[CAT] = '${result}'`

      const result_json = item.length === 1 ? col.json
                        : item.length === 2 ? 'Punch'
                        : col.json; // 그 외는 빈값

      console.log(item, col.json, dataSource, filterString_)

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps(result_json, dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },


    // ---------------------------------------------------------------------------------------------------
    call_Navi(selection) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).selectAll('text').style('fill', '#EC407A')
        d3.select(this).transition().duration(50).style('opacity', .8)
      })
      .on('mouseout', function() {
        d3.select(this).selectAll('text').style('fill', '#757575')
        d3.select(this).transition().duration(50).style('opacity', 1)
      })
      .on('click', () => {
        this.canvasForms.remove()
        this.draw_Forms()
      })
    },


    call_Link(selection, sys, data) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).style('opacity', .4)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).style('opacity', 1)
      })
      .on('click', () => {
        this.draw_Reflash(sys, data)
      })
    },
  } 
}